// Relative publication time displayed on listing cards.

export const getRelativeTime = createdAt => {
  if (!createdAt) return null;
  const now = Date.now();
  const created = new Date(createdAt).getTime();
  if (!Number.isFinite(created)) return null;
  const diffMs = Math.max(0, now - created);
  const diffMin = Math.floor(diffMs / 60000);
  const diffHour = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffMs / 86400000);
  const diffMonth = Math.floor(diffDay / 30);
  const diffYear = Math.floor(diffDay / 365);

  if (diffMin < 1) return 'hace un momento';
  if (diffMin < 60) return `hace ${diffMin} ${diffMin === 1 ? 'minuto' : 'minutos'}`;
  if (diffHour < 24) return `hace ${diffHour} ${diffHour === 1 ? 'hora' : 'horas'}`;
  if (diffDay < 30) return `hace ${diffDay} ${diffDay === 1 ? 'día' : 'días'}`;
  if (diffMonth < 12) return `hace ${diffMonth} ${diffMonth === 1 ? 'mes' : 'meses'}`;
  return `hace ${diffYear} ${diffYear === 1 ? 'año' : 'años'}`;
};
